var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13996 0 0 3.13996 0 7C0 10.86 3.13996 14 7 14C10.86 14 14 10.8595 14 7C14 3.14051 10.86 0 7 0ZM7 12.9156C3.73857 12.9156 1.08443 10.262 1.08443 7C1.08443 3.73803 3.73857 1.08443 7 1.08443C10.262 1.08443 12.9156 3.73803 12.9156 7C12.9156 10.262 10.2614 12.9156 7 12.9156Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2114 4.56587C9.99066 4.36525 9.64744 4.38097 9.44575 4.60273L6.13822 8.24481L4.5403 6.62034C4.32937 6.4067 3.9867 6.40345 3.77361 6.61383C3.55997 6.82367 3.55672 7.16689 3.7671 7.38053L5.76733 9.41383C5.86981 9.51793 6.00861 9.57595 6.15392 9.57595C6.15717 9.57595 6.16097 9.57595 6.16422 9.5765C6.31388 9.57325 6.45486 9.50926 6.55516 9.39866L10.2482 5.33204C10.4494 5.10971 10.4331 4.76704 10.2114 4.56587Z",
    fill: "#474747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f994ca0a232b6b252becb0126f2ea10f.svg";
export { ForwardRef as ReactComponent };